import * as yup from "yup";

const EsuraApiConnectionPropertiesFormValidation= yup.object().shape({
baseUrl: yup
  .string()
  .url()
  .required("A URL é obrigatória"),
url: yup
  .string()
  .url()
  .required("A URL é obrigatória"),
  username: yup
    .string()
    .min(3, "O nome de usuário deve ter pelo menos 3 caracteres")
    .required("O nome de usuário é obrigatório"),

  password: yup
    .string()
    .min(6, "A senha deve ter pelo menos 6 caracteres")
    .required("A senha é obrigatória"),
});
export default EsuraApiConnectionPropertiesFormValidation;